import router from "@/router";

router.addRoute({
    path: "/hotel/sadmin/icon",
    name: "icon",
    meta: { requiresAuth: false },
    component: () => import("./View.vue"),
});
